import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from 'src/app/shared/models/service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ServiceModalAjoutComponent } from '../modal/service-modal-ajout/service-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ServiceModalDetailComponent } from '../modal/service-modal-detail/service-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-service',
	templateUrl: './list-service.component.html',
	styleUrls: ['./list-service.component.scss']
})
export class ListServiceComponent implements OnInit {
	service: Service[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	serviceCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editServiceModalRef: BsModalRef;
	addServiceModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getService();
		this.isAddable = true;
	}

	getService(): void {
		this.isListingLoading = true;
		this.facade.serviceService.getAllService().subscribe({
			next: (val) => {
				this.service = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.service.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.service = [];
			}
		});
	}

	selectService(service: Service): void {
		const link = ['/service', service.id];
		this.router.navigate(link);
	}

	importService(event: any): void {
		this.serviceCsvFile = event.target.files[0];

		this.facade.serviceService
			.importService(this.serviceCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} service ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getService();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addServiceModalRef = this.modalService.show(
			ServiceModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addServiceModalRef.onHide.subscribe((reason: string | any) => {
			this.getService();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(service: Service) {
		const initialState = {
			service: service
		};
		this.editServiceModalRef = this.modalService.show(
			ServiceModalDetailComponent,
			{
				class: 'modal-lg',
				backdrop: 'static',
				initialState
			}
		);

		this.editServiceModalRef.onHide.subscribe((reason: string | any) => {
			this.getService();
		});
	}
}
